<div *ngIf="loading">
  <img src="https://cdn.mango-soft.com/mango-core/loading.gif" />
  <p>{{ text }}</p>
</div>
